<app-loading class="flex align-items-center justify-content-center"
  *ngIf="loading"></app-loading>
<div class="content-display" [class.invisible]="loading">
  <div class="border-bottom-1 font-bold mb-2">
    <label>Models to be run*</label>
  </div>
  <p-accordion #accordion [multiple]="false" [activeIndex]="activeIndex" (onClose)="onClose($event)"
    (onOpen)="onOpen($event)">
    <p-accordionTab [selected]="true">
      <ng-template pTemplate="icon">
        <app-button [text]="true" [plain]="true" [size]="'small'" [icon]="'pi pi-angle-down'" [iconPos]="'right'"
          [disabled]=true></app-button>
      </ng-template>
      <!-- Header -->
      <ng-template class="flex" pTemplate="header">
        <div class="ml-2 flex align-items-center text-color">
          <span class="vertical-align-middle">{{modelHeader}}</span>
        </div>
        <div class="flex align-items-end">
          <app-button [text]="true" [disabled]="true" [plain]="true" [icon]="'pi pi-check-square'"
            [iconPos]="'right'"></app-button>
        </div>
      </ng-template>

      <!-- Content -->
      <ng-template pTemplate="content">
        <div class="formgrid grid no-ml-mr">
          <div class="setup-col">
            <div class="col-3 font-bold fw-320 pad-1">
              <app-input-text [disabled]="!selectedProject || !canMakeEdits" [label]="'Chemical'" [useTitle]="true"
                [model]="chemicalName" [isRequired]="true" [isValid]="isChemicalNameValid"
                (onChangeEvent)="chemicalNameChanged($event)"></app-input-text>
            </div>
            <div class="col-3 font-bold fw-320 pad-1">
              <label [ngClass]="!isStatesToIncludeValid && isStatesToIncludeRequired ? 'lbl-invalid' : 'lbl-valid'">{{statesToIncludeLabel}}</label>
              <div>
                <p-multiSelect
                  class="w-12"
                  [ngClass]="!isStatesToIncludeValid && isStatesToIncludeRequired ? 'dd-invalid' : 'dd-valid'"
                  [disabled]="!selectedProject || !canMakeEdits || !isStatesToIncludeRequired"
                  [options]="getOptionsByModel(modelHeader, this.controlledVocabularyService.statesToIncludeOptions)"
                  appendTo="body"
                  [placeholder]="statesToIncludePlaceholder"
                  (onChange)="statesToIncludeSelectionChanged($event)"
                  (onSelectAllChange)="statesToIncludeSelectAllChanged($event)"
                  [selectAll]="selectAllStates"
                  [(ngModel)]="selectedStatesToInclude"
                  [optionLabel]="'long_value'"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="28"></p-multiSelect>
              </div>
            </div>
            <div class="col-3 font-bold fw-320 pad-1">
              <label [ngClass]="isCropUseValid ? 'lbl-valid' : 'lbl-invalid'">Crop Use* (At least one selection per region required)</label><br>
                <p-multiSelect
                  class="w-12 fh-20"
                  [ngClass]="isCropUseValid ? 'dd-valid' : 'dd-invalid'"
                  [options]="formattedCropUseOptions"
                  optionLabel="label"
                  optionValue="value"
                  [disabled]="!selectedProject || !canMakeEdits"
                  appendTo="body"
                  [placeholder]="'Select crop use'"
                  (onChange)="onCropUseChanged($event.value)"
                  (onSelectAllChange)="selectAllCropUseChanged($event)"
                  [selectAll]="selectAllCropUseOptions"
                  [(ngModel)]="selectedCropUseValues"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="30"></p-multiSelect>
            </div>
          </div>
          <div class="setup-col">
            <div class="col-3 font-bold fw-190 pad-1">
              <app-dropdown [label]="'Species Distribution'"
                [options]="getOptionsByModel(modelHeader, this.controlledVocabularyService.speciesDistributionOptions)" optionLabel="long_value"
                [model]="selectedSpeciesDistribution" [isRequired]="true"
                [hardDisabled]="!selectedProject || !canMakeEdits" [showClear]="true"
                [placeholder]="'Select a Species Distribution'" [isValid]="isSpeciesDistributionValid"
                (onChangeEvent)="speciesDistributionSelectionChanged($event.value)">
              </app-dropdown>
            </div>
            <div class="col-3 font-bold fw-190 pad-1">
              <label [ngClass]="!isBufferDistancesValid ? 'lbl-invalid' : 'lbl-valid'">Offsite Transportation Zone Distances (m)*</label>
              <div>
                <p-multiSelect
                  class="w-12"
                  [ngClass]="!isBufferDistancesValid ? 'dd-invalid' : 'dd-valid'"
                  [options]="getOptionsByModel(modelHeader, bufferDistancesOptionsWithSettings)"
                  [disabled]="!selectedProject || !canMakeEdits"
                  appendTo="body"
                  (onChange)="bufferDistancesChanged($event.value)"
                  (onSelectAllChange)="bufferDistancesSelectAllChanged($event)"
                  [selectAll]="selectAllBufferDistances"
                  [(ngModel)]="selectedBufferDistances"
                  [optionLabel]="'short_value'"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="28"></p-multiSelect>
              </div>
            </div>
          </div>
          <div class="setup-col mr-4">
            <div class="col-2 font-bold fw-190 pad-1">
              <app-dropdown [label]="'Include Drift'" [optionLabel]="'display'" [optionValue]="'value'"
                [isRequired]="true" [hardDisabled]="!selectedProject || !canMakeEdits" [model]="includeDrift"
                [options]="includeDriftOptions" [showClear]="true" [isValid]="isIncludeDriftValid"
                [placeholder]="'Select'" (onChangeEvent)="includeDriftSelectionChanged($event)">
              </app-dropdown>
            </div>
            <div class="col-2 font-bold fw-190 pad-1">
              <app-dropdown
                [label]="'Adjust for PCT'"
                [isRequired]="true"
                [hardDisabled]="!selectedProject || !canMakeEdits"
                [model]="adjustForPCT"
                [options]="['Yes', 'No']"
                [showClear]="true"
                [isValid]="isAdjustForPCTValid"
                [placeholder]="'Select'"
                (onChangeEvent)="adjustForPCTSelectionChanged($event)">
              </app-dropdown>
            </div>
            <div class="col-3 font-bold fw-250 pad-1">
              <label [ngClass]="isPCTValuesFileSelected ? (!isPCTValuesFileValid ? 'lbl-invalid' : 'lbl-valid') : 'lbl-valid'">PCT Values (This must be a .csv file)</label><br>
              <label *ngIf="this.isPCTFileNameContainSpaces" class="lbl-invalid">File name can not include spaces</label>
              <div class="file-upload-container mt-2 mb-2">
                <input type="file" (click)="onFileInputClick($event, this.controlledVocabularyService.pctSampleFileName)" (change)="onFileSelected($event, '.csv', 'isPCTValuesFileValid', 'isPCTFileNameContainSpaces', 'isPCTValuesFileSelected', uploadedPCTFilename)" accept=".csv"
                  [disabled]="!selectedProject || !canMakeEdits || !isPCT || (uploadedPCTFilename != undefined && uploadedPCTFilename.length > 0)" #pctValuesFileSelected>
              </div>
              <div *ngIf="uploadedPCTFilename != undefined && uploadedPCTFilename.length > 0" class="mt-2 mb-2 row-1">
                <button class="p-button p-button-link" type="button" role="button" (click)="this.downloadProjectFile(uploadedPCTFilename)" [disabled]="!selectedProject || !canMakeEdits">{{uploadedPCTFilename}}</button>
                <button class="p-button p-component p-button-danger" (click)="this.udlOverlapToolContainerService.deleteUploadedFile(selectedProject?.projectPk!, this.udlOverlapToolContainerService.pctValues)" [disabled]="!selectedProject || !canMakeEdits">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
              <p-button styleClass="standard-button" class="p-button-outlined" label="Download PCT" [disabled]="!selectedProject || !canMakeEdits || !isPCT" (click)="udlOverlapToolContainerService.downloadDefaultPCTFile()"></p-button>
            </div>
          </div>
          <div class="setup-col">
            <div class="col-3 font-bold fw-320 pad-1">
              <label [ngClass]="!isRegionsToIncludeValid ? 'lbl-invalid' : 'lbl-valid'">Regions to Include*</label>
              <div>
                <p-multiSelect class="w-12" [ngClass]="!isRegionsToIncludeValid ? 'dd-invalid' : 'dd-valid'"
                  [disabled]="!selectedProject || !canMakeEdits"
                  [options]="getOptionsByModel(modelHeader, this.controlledVocabularyService.regionsToIncludeOptions)" appendTo="body"
                  [placeholder]="regionsToIncludePlaceholder" (onChange)="regionsToIncludeSelectionChanged($event.value)"
                  (onSelectAllChange)="regionsToIncludeSelectAllChanged($event)" [selectAll]="selectAllRegions"
                  [(ngModel)]="selectedRegionsToInclude" [optionLabel]="'short_value'" [virtualScroll]="true"
                  [virtualScrollItemSize]="28"></p-multiSelect>
              </div>
            </div>

            <div class="col-3 font-bold fw-320 pad-1">
              <label [ngClass]="!isOnOffFieldConsiderationsValid ? 'lbl-invalid' : 'lbl-valid'">On/Off Field Considerations*</label>
              <div>
                <p-multiSelect
                  class="w-12"
                  [ngClass]="!isOnOffFieldConsiderationsValid ? 'dd-invalid' : 'dd-valid'"
                  [options]="getOptionsByModel(modelHeader, this.controlledVocabularyService.onOffFieldConsiderationsOptions)"
                  [disabled]="!selectedProject || !canMakeEdits"
                  appendTo="body"
                  [placeholder]="onOffFieldConsiderationsPlaceholder"
                  (onChange)="onOffFieldConsiderationsChanged($event.value)"
                  (onSelectAllChange)="onOffFieldConsiderationsSelectAllChanged($event)"
                  [selectAll]="selectAllOnOffFieldConsiderations"
                  [(ngModel)]="selectedOnOffFieldConsiderations"
                  [optionLabel]="'short_value'"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="30"></p-multiSelect>
              </div>
            </div>
            <div class="col-3 font-bold fw-320 pad-1">
              <label [ngClass]="this.isOnAndOffConsiderationsFileSelected ? (!isOnAndOffConsiderationsFileValid ? 'lbl-invalid' : 'lbl-valid') : 'lbl-valid'">On/Off Considerations (This must be a .xlsx file)</label><br>
              <label *ngIf="this.isOnAndOffConsiderationsFileNameContainSpaces" class="lbl-invalid">File name can not include spaces</label>
              <div class="file-upload-container mt-2 mb-2">
                <input type="file" (click)="onFileInputClick($event, this.controlledVocabularyService.onOffConsiderationsSampleFileName)" (change)="onFileSelected($event, '.xlsx', 'isOnAndOffConsiderationsFileValid', 'isOnAndOffConsiderationsFileNameContainSpaces', 'isOnAndOffConsiderationsFileSelected', uploadedOnOffConsiderationsFilename)" accept=".xlsx"
                  [disabled]="!selectedProject || !canMakeEdits || (uploadedOnOffConsiderationsFilename != undefined && uploadedOnOffConsiderationsFilename.length > 0)" #onAndOffConsiderationsFileSelected>
              </div>
              <div *ngIf="uploadedOnOffConsiderationsFilename != undefined && uploadedOnOffConsiderationsFilename.length > 0" class="mt-2 mb-2 row-1">
                <button class="p-button p-button-link" type="button" role="button" (click)="this.downloadProjectFile(uploadedOnOffConsiderationsFilename)" [disabled]="!selectedProject || !canMakeEdits">{{uploadedOnOffConsiderationsFilename}}</button>
                <button class="p-button p-component p-button-danger" (click)="this.udlOverlapToolContainerService.deleteUploadedFile(selectedProject?.projectPk!, this.udlOverlapToolContainerService.onOffConsiderations)" [disabled]="!selectedProject || !canMakeEdits">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
              <p-button styleClass="standard-button" class="p-button-outlined" label="Download On/Off" (click)="udlOverlapToolContainerService.downloadDefaultOnOffConsiderationsFile()" [disabled]="!selectedProject || !canMakeEdits"></p-button>
            </div>
          </div>
          <br>
          <div class="formgrid grid summary-report-specifications">
            <div class="border-bottom-1 font-bold mb-2 summary-report-specifications-label">
              <label>Summary Report Specifications</label>
            </div>
              <div class="setup-col">
                <div class="col-3 font-bold mr-6 fw-320 pad-1">
                  <app-dropdown
                    [label]="'Offsite Transportation Zone Distance (m) to use in the Summary Report'"
                    [options]="getOptionsByModel(modelHeader, bufferDistanceInSummaryReportOptions)"
                    optionLabel="short_value"
                    [hardDisabled]="!selectedProject || !canMakeEdits"
                    [model]="selectedBufferDistanceInSummaryReport"
                    [isRequired]="true"
                    [showClear]="true"
                    [placeholder]="'Select summary report distance'"
                    [isValid]="isBufferDistanceInSummaryReportValid"
                    (onChangeEvent)="bufferDistanceInSummaryReportSelectionChanged($event.value)">
                  </app-dropdown>
                </div>
              </div>
              <div class="setup-col">
                <div class="col-3 font-bold mr-8 fw-320 pad-1">
                  <label [ngClass]="isObligateAndIndirectRelationshipFileSelected ? (!isObligateAndIndirectRelationshipFileValid ? 'lbl-invalid' : 'lbl-valid') : 'lbl-valid'">Obligate/Indirect Relationship (This must be a .csv file)</label><br>
                  <label *ngIf="this.isObligateAndIndirectRelationshipFileNameContainSpaces" class="lbl-invalid">File name can not include spaces</label>
                  <div class="file-upload-container mt-2 mb-2">
                    <input type="file" (click)="onFileInputClick($event, this.controlledVocabularyService.indirectRelationshipsSampleFileName)" (change)="onFileSelected($event, '.csv', 'isObligateAndIndirectRelationshipFileValid', 'isObligateAndIndirectRelationshipFileNameContainSpaces', 'isObligateAndIndirectRelationshipFileSelected', uploadedObligateAndIndirectRelationshipFilename)" accept=".csv"
                      [disabled]="!selectedProject || !canMakeEdits || (uploadedObligateAndIndirectRelationshipFilename != undefined && uploadedObligateAndIndirectRelationshipFilename.length > 0)" #obligateAndIndirectRelationshipFileSelected>
                  </div>
                  <div *ngIf="uploadedObligateAndIndirectRelationshipFilename != undefined && uploadedObligateAndIndirectRelationshipFilename.length > 0" class="mt-2 mb-2 row-1">
                    <button class="p-button p-button-link" type="button" role="button" (click)="this.downloadProjectFile(uploadedObligateAndIndirectRelationshipFilename)" [disabled]="!selectedProject || !canMakeEdits">{{uploadedObligateAndIndirectRelationshipFilename}}</button>
                    <button class="p-button p-component p-button-danger" (click)="this.udlOverlapToolContainerService.deleteUploadedFile(selectedProject?.projectPk!, this.udlOverlapToolContainerService.obligateAndIndirectRelationship)" [disabled]="!selectedProject || !canMakeEdits">
                      <i class="pi pi-trash"></i>
                    </button>
                  </div>
                  <p-button styleClass="standard-button" class="p-button-outlined" label="Download Relationships" (click)="udlOverlapToolContainerService.downloadDefaultIndirectRelationshipsFile()" [disabled]="!selectedProject || !canMakeEdits"></p-button>
                </div>
              </div>
            </div>
            <div class="clear-inputs-container">
              <div class="formgrid grid mt-6 mb-2 clear-button">
                <div class="col-12">
                  <p-button [disabled]="false" styleClass="standard-button" class="p-button-outlined mr-6" label="Clear Model Inputs" (onClick)="clearModelInputs()" [disabled]="!selectedProject || !canMakeEdits"></p-button>
                </div>
              </div>
            </div>
        </div>
      </ng-template>
    </p-accordionTab>
  </p-accordion>
</div>
